import styled from 'styled-components';
import { SearchOutlined } from '@ant-design/icons';

export const StyledAutocompleteWrapper = styled.div.withConfig({
    shouldForwardProp: (prop) => !['error'].includes(prop),
})<{ error?: boolean }>`
    width: 100%;

    .ant-input-affix-wrapper-borderless,
    .ant-input-affix-wrapper {
        border-radius: var(--border-radius-normal);
        border: 1px solid var(--gray-5);
        background-color: var(--gray-1);
        transition: all 0.2s ease;
        padding-inline: 12px;
        width: 100%;
        border-color: ${({ error }) => (error ? 'var(--error-normal)' : 'var(--gray-5)')};
    }

    .ant-input-affix-wrapper:hover,
    .ant-input-affix-wrapper-borderless:hover {
        border: 1px solid;
        border-color: ${({ error }) => (error ? 'var(--error-normal)' : 'var(--brand-5)')};
    }

    .ant-input-affix-wrapper-focused {
        border: 1px solid var(--brand-6);
        border-color: ${({ error }) => (error ? 'var(--error-normal)' : 'var(--brand-5)')};
        box-shadow: ${({ error }) => (error ? 'var(--error-box-shadow)' : 'var(--box-shadow-1)')};
        background-color: var(--gray-1);
        color: var(--gray-9);

        .ant-input-suffix {
            display: none;
        }
    }
`;

export const StyledSearchIcon = styled(SearchOutlined)`
    color: var(--brand-3);
`;
